/* eslint react-hooks/exhaustive-deps: "warn" */
import { useEffect, useRef } from 'react';

import { useInt } from 'hooks/useInt';

import { TitleBlock } from 'ui/atoms/TitleBlock/TitleBlock';
import { Section } from 'ui/molecules/Section/Section';

import styles from './MsvGraph.module.scss';

export const MsvGraph = () => {
  const { t } = useInt();
  const svgRef = useRef<SVGSVGElement>(null);

  useEffect(() => {
    const svg = svgRef.current;
    if (!svg) {
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          svg.classList.add(styles.drawn);
          observer.disconnect();
        }
      },
      { threshold: 0.3 },
    );
    observer.observe(svg);
    return () => observer.disconnect();
  }, []);

  return (
    <Section background="#0e1526" className={styles.root}>
      <div className={styles.grid}>
        <div className={styles.copy}>
          <TitleBlock
            title={
              <>
                {t('One officer.')}
                <br />
                {t('Three companies.')}
                <br />
                {t('Two bans that stopped working.')}
              </>
            }
            description={t(
              'Suspension lists built on emails, device fingerprints and card tokens cost about forty minutes to defeat. Incorporating a fresh entity leaves the same officer name filed in the same register, and the graph carries the suspension forward.',
            )}
            theme="dark"
            align="left"
          />
        </div>

        <div className={styles.svgWrap}>
          <svg
            ref={svgRef}
            className={styles.svg}
            viewBox="0 0 620 400"
            xmlns="http://www.w3.org/2000/svg"
            aria-label={t('Graph linking three companies to one common officer')}
          >
            <path
              className={styles.gline}
              style={{ '--len': '270' } as React.CSSProperties}
              d="M268 64 C 344 64, 360 190, 430 190"
            />
            <path
              className={`${styles.gline} ${styles.d2}`}
              style={{ '--len': '175' } as React.CSSProperties}
              d="M268 190 H 430"
            />
            <path
              className={`${styles.gline} ${styles.d3}`}
              style={{ '--len': '270' } as React.CSSProperties}
              d="M268 316 C 344 316, 360 190, 430 190"
            />

            <rect className={styles.gboxHit} x="6" y="20" width="262" height="88" rx="12" />
            <text className={styles.gt} x="28" y="52">
              Atlas Parts Group Ltd
            </text>
            <text className={styles.gm} x="28" y="74">
              UK · 07XXXXXX · 2021–2024
            </text>
            <text className={`${styles.gs} ${styles.gsBad}`} x="28" y="94">
              SUSPENDED
            </text>

            <rect className={styles.gboxHit} x="6" y="146" width="262" height="88" rx="12" />
            <text className={styles.gt} x="28" y="178">
              Velmark Supply OÜ
            </text>
            <text className={styles.gm} x="28" y="200">
              EE · 14XXXXXX · 2024–2025
            </text>
            <text className={`${styles.gs} ${styles.gsBad}`} x="28" y="220">
              SUSPENDED
            </text>

            <rect className={styles.gboxNew} x="6" y="272" width="262" height="88" rx="12" />
            <text className={styles.gt} x="28" y="304">
              Kowalski Handel sp. z o.o.
            </text>
            <text className={styles.gm} x="28" y="326">
              PL · KRS 0000XXXXXX · Apr 2026
            </text>
            <text className={`${styles.gs} ${styles.gsNew}`} x="28" y="346">
              APPLYING NOW
            </text>

            <rect className={styles.officerBox} x="430" y="138" width="188" height="104" rx="14" />
            <text className={styles.officerName} x="452" y="176">
              D. Kowalski
            </text>
            <text className={styles.officerFilings} x="452" y="200">
              3 OFFICER FILINGS
            </text>
            <text className={styles.officerMeta} x="452" y="220">
              UK · EE · PL registers
            </text>
          </svg>
        </div>
      </div>
    </Section>
  );
};
